import { SyntheticEvent, useState } from 'react';
import { EVENT_ROLE, STATUS } from '@type/db-types';
import { Modal } from 'antd';
import { EventWithMembership } from '@modules/supabase/events';
import { hasDatePassed } from '@utils/date-utils';
import JoinEventsForm from './JoinEventsForm';
import useEventContext from '@hooks/useEventContext';
import { Button } from '@mui/material';

export function RegisterNowButton({ event }: { event: EventWithMembership }) {
    const [showModal, setShowModal] = useState(false);
    const { registrationCount } = useEventContext();

    const isSignedUp = event?.memberships?.find(
        (m) => m.status === STATUS.ACTIVE && m.role === EVENT_ROLE.PARTICIPANT,
    );
    // const { role } = useTeams();
    // const isCoach = [TEAM_ROLE.COACH, TEAM_ROLE.OWNER].includes(role as TEAM_ROLE);

    if (!event) return null;

    const eventRegistrationClosed =
        hasDatePassed(event.startAt) ||
        !!(
            registrationCount &&
            typeof event.maxEntries == 'number' &&
            registrationCount >= event.maxEntries
        );

    return (
        <>
            <Button
                disabled={eventRegistrationClosed}
                // fullWidth
                variant="contained"
                onClick={(e) => {
                    // Prevent underlying div from triggering click event
                    e.stopPropagation();
                    setShowModal(true);
                    return false;
                }}
            >
                {eventRegistrationClosed
                    ? 'Registration Closed'
                    : isSignedUp
                      ? 'Update Registration'
                      : 'Register Now'}
            </Button>

            <Modal
                title={
                    <span className="custom-heading">
                        Add wrestlers to {event.name} - ${event.fee}
                    </span>
                }
                key={`register-now-${event.id}`}
                open={showModal}
                width={'1200px'}
                footer={false}
                destroyOnClose={true}
                onCancel={() => setShowModal(false)}
                // Prevent underlying div from triggering click event
                wrapProps={{ onClick: (e: SyntheticEvent) => e.stopPropagation() }}
            >
                <JoinEventsForm event={event} onClose={() => setShowModal(false)} />
            </Modal>
        </>
    );
}
